module.exports = __webpack_public_path__ + "static/2_3_game-tree-4-d2c016a0d569e9d8a4ea67e39c84bd36.svg";